// extracted by mini-css-extract-plugin
export default {"scriptFrame":"scriptFrame_scriptFrame__0Sayv","scriptFrameGenerating":"scriptFrame_scriptFrameGenerating__ebRss","scriptBorderSpin":"scriptFrame_scriptBorderSpin__JFdPc"};